import { Box, Button, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const RecordingModalContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "0",
  maxWidth: "660px",
});

export const RecordingModalTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  color: colors.text.primary,
  marginBottom: "8px",
  textAlign: "center",
});

export const RecordingModalSubtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.secondary,
  marginBottom: "32px",
  textAlign: "center",
  maxWidth: "400px",
});

export const ProgressContainer = styled(Box)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "24px",
});

export const TimerContainer = styled(Box)({
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
});

interface TimerTextProps {
  isWarning?: boolean;
}

export const TimerText = styled(Typography)<TimerTextProps>(
  ({ isWarning }) => ({
    fontSize: "48px",
    fontWeight: 600,
    color: isWarning ? "#D32F2F" : colors.text.primary,
  })
);

export const PauseButton = styled(Button)({
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,
  color: colors.primary.main,
  backgroundColor: "#FFFFFF",
  border: `1px solid ${colors.primary.main}`,
  padding: "10px 20px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minHeight: "44px",
  "&:hover": {
    backgroundColor: "rgba(58, 138, 185, 0.04)",
    borderColor: colors.primary.dark,
  },
});

export const ContinueButton = styled(Button)({
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,
  color: "#FFFFFF",
  backgroundColor: colors.amber.main,
  border: "none",
  padding: "10px 20px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minHeight: "44px",
  "&:hover": {
    backgroundColor: colors.amber.dark,
    color: "#FFFFFF",
  },
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "16px",
  marginTop: "24px",
  justifyContent: "center",
  width: "100%",
});

export const CancelButton = styled(Button)({
  minWidth: "120px",
  height: "48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  color: colors.primary.main,
  border: `1px solid ${colors.primary.main}`,
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(58, 138, 185, 0.08)",
  },
});

export const ProceedButton = styled(Button)({
  minWidth: "120px",
  height: "48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: colors.amber.main,
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: colors.amber.dark,
  },
});

export const WarningContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px 20px",
  backgroundColor: "#FFF5F4",
  borderRadius: "12px",
  marginTop: "24px",
  width: "100%",
  marginBottom: "16px",
});

export const WarningIconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const WarningTextContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
});

export const WarningTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: "#B71C1C",
  lineHeight: "24px",
});

export const WarningMessage = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: "#B71C1C",
  lineHeight: "20px",
});
